// extracted by mini-css-extract-plugin
export default {"container":"style_container__2QxiX","header":"style_header__dsnaW","main":"style_main__5SsX0"};